import { Component, Inject, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PosterService } from '../../features/poster/poster.service';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { NoDataComponent } from '../../shared/components/no-data/nodata.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TagsLanguageService } from '../../features/tags-language/tagsLanguage.service';
import { ToastrService } from 'ngx-toastr';
import { SafeUrlPipe } from '../../core/pipes/pdf-viewer/safe-url.pipe';
import { PermissionDirective } from '../../shared/components/directives/permissions.directives';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { ContentLoaderComponent } from '../../shared/components/content-loader-component/contentLoader.component';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-posters-list-page',
  imports: [
    CommonModule,
    NoDataComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ContentLoaderComponent,
    PermissionDirective,
  ],
  templateUrl: './posters-list-page.component.html',
  styleUrl: './posters-list-page.component.scss',
})
export class PostersListPageComponent {
  readonly dialog = inject(MatDialog);
  public languages: any[] = [];
  public langCode: String = '';
  public storyList: any[] = [];
  private searchSubject = new Subject<string>();
  searchTerm: string = '';
  noData = false;
  loading = false;

  constructor(
    private router: Router,
    private tagsService: TagsLanguageService,
    private posterService: PosterService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getPosters(this.langCode);
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.getPosters(this.langCode, searchTerm);
      });
  }

openDialog(story: any): void {
  const dialogRef = this.dialog.open(PosterModal, {
    panelClass: 'custom-story-panel',
    data: story,
    maxWidth: '95vw',
    maxHeight: '95vh',
    width: 'auto',
    height: 'auto',
    autoFocus: false
  });
}
  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  getLanguages(): void {
    this.tagsService.getLangauges().subscribe({
      next: (res) => {
        if (res?.data) {
          this.languages = res?.data;
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onLanguageSelect(event: any) {
    this.langCode = event.value;
    this.getPosters(this.langCode);
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/placeHolderImage.jpg';
  }
  getPosters(lang: any, search = ''): void {
    this.loading = true;
    this.posterService.getPosters(lang, search).subscribe({
      next: (res) => {
        if (res?.data) {
          this.storyList = res.data.filter(
            (poster: any) =>
              poster.posterTranslations && poster.posterTranslations.length > 0
          );
          if (this.storyList.length === 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
          this.loading = false;
        }
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  getPreferredTitle(translations: any[]): string {
    if (!translations || translations.length === 0) return 'Untitled';
    const primary = translations.find((t) => t.langId === 1);
    if (primary) return primary.title;
    return translations[0].title;
  }

  onDeletePoster(posterID: number): void {
    const dialogRef = this.dialog.open(ConfirmDialog);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.deletePoster(posterID);
      }
    });
  }

  deletePoster(id: any): void {
    this.posterService.deletePoster(id).subscribe({
      next: (res) => {
        this.toastr.success(res.message);
        this.getPosters(this.langCode);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onPosterEdit(id: any): void {
    this.router.navigate([`/poster/edit/${id}`]);
  }
}

@Component({
  selector: 'poster-modal',
  templateUrl: './poster-modal/poster-modal.html',
  styleUrl: './poster-modal/poster-modal.component.scss',
  imports: [MatDialogContent, SafeUrlPipe, CommonModule],
})
export class PosterModal {
  readonly dialogRef = inject(MatDialogRef<PosterModal>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  checkFile(file: string): boolean {
    return file.toLowerCase().includes('.pdf');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
